export const LOAD_LEADERBOARD_REQUEST = '[leaderboard] load request';
export const LOAD_LEADERBOARD_SUCCESS = '[leaderboard] load success';
export const LOAD_LEADERBOARD_FAILURE = '[leaderboard] load failure';
export const ADD_WIN_REQUEST = '[leaderboard] add win request';
export const ADD_WIN_SUCCESS = '[leaderboard] add win success';
export const ADD_WIN_FAILURE = '[leaderboard] add win failure';
export const UPDATE_INITIALS_REQUEST = '[leaderboard] update initials request';
export const UPDATE_INITIALS_SUCCESS = '[leaderboard] update initials success';
export const UPDATE_INITIALS_FAILURE = '[leaderboard] update initials failure';
